import React, { useState, useEffect } from "react";
import ContactMenu from "../../components/contact/ContactMenu";
import PageBanner from "../../components/PageBanner";
import AboutUsService from "../../services/aboutUs";
import DateParagraph from "../../components/content/DateParagraph";
import BulletParagraph from "../../components/content/BulletParagraph";
import RichText from "../../components/content/RichText";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function AboutUs() {
  let [aboutUsData, setAboutUsData] = useState([]);
  let [aboutUsBanner, setAboutUsBanner] = useState([]);
  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getAboutUsData();
    getAboutUsBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getAboutUsData = async () => {
    try {
      let res = await AboutUsService.getContent();
      setAboutUsData(res);
    } catch {
      console.error();
    }
  };

  const getAboutUsBanner = async () => {
    try {
      let res = await BannerService.getBanner(5);
      setAboutUsBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "About us", href: "/about-us" }];

  return (
    <div id="about-us" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"เกี่ยวกับเรา"}
        text_en={"About us"}
        banner={aboutUsBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          <div className="mt-[35px] mb-[166px]">
            <ContactMenu isOpen={1} lang={lang} />

            <div className="mt-[44px]">
              {aboutUsData &&
                aboutUsData.map((item, i) => (
                  <div key={i}>
                    <div className="my-[40px]">
                      <h1 className="text-subheading text-left font-bold inline-block border-b-[2px] border-lightGray pb-[5px]">
                        {lang === "th" ? item.title_th : item.title_en}
                      </h1>
                    </div>
                    {(item.type === "global.detail" ||
                      item.type === "global.rich-detail") && (
                      <RichText
                        html={
                          lang === "th"
                            ? item.content[0].detail_TH
                            : item.content[0].detail_EN
                        }
                      />
                    )}

                    {item.type === "about.table" && (
                      <div className="flex flex-col gap-[58px] text-left font-medium">
                        {item.content &&
                          item.content.map((data, i) => (
                            <div key={i}>
                              {DateParagraph(
                                lang === "th" ? data.left_TH : data.left_EN,
                                lang === "th" ? data.right_TH : data.right_EN
                              )}
                            </div>
                          ))}
                      </div>
                    )}

                    {item.type === "about.bullet" && (
                      <div className="flex flex-col gap-[32px] text-left font-medium">
                        <RichText
                          html={
                            lang === "th"
                              ? item.content[0].detail_TH
                              : item.content[0].detail_EN
                          }
                        />
                        {item.content &&
                          item.content.map((data, i) => (
                            <div key={i}>
                              {BulletParagraph(
                                lang === "th" ? data.title_TH : data.title_EN,
                                lang === "th" ? data.detail_TH : data.detail_EN
                              )}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
